module.exports = __webpack_public_path__ + "img/eeuu.cd604fad.jpg";